import React, { Component } from 'react';
import { Pagination } from "react-bootstrap";
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from './components/Table';
import API from '../../services/API';
import { PAGE_LIMIT } from "./config";

class DynamicCutoff extends Component {
    constructor(props) {
        super(props);

        this.state = {
            affidValues: [],
            subidValues: [],
            report: [],
            sortParam: null,
            sortOrder: 1,
            pagesTotal: 0,
            activePage: 1,
            isLoading: true
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handlePageSelect = this.handlePageSelect.bind(this);
        this.updateFactor = this.updateFactor.bind(this)
    }

    componentDidMount() {
        API.DynamicCutoff.getAffid().then((affidValues) => {
            this.setState({ affidValues, isLoading: false })
        })
    }

    componentWillUpdate(nextProps, nextState) {
        const { report, sortParam, sortOrder } = nextState;

        if(this.state.sortParam !== sortParam || this.state.sortOrder !== sortOrder) {
            this.sortReport(report, sortParam, sortOrder);

            this.setState({ report });
        }
    }

    sortReport(report, sortParam, sortOrder) {
        report.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    handleSubmit(filters, type) {
        this.setState({ isLoading: true });

        if(type === "subid") {
            API.DynamicCutoff.getSubidsAll(filters).then((subidValues) => {
                this.setState({ subidValues, isLoading: false })
            });
        } else {
            API.DynamicCutoff.getAll(filters, type).then(({ report }) => {
                const pagesTotal = Math.ceil(report.length / PAGE_LIMIT);

                this.setState({ report, pagesTotal, isLoading: false })
            });
        }
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    handlePageSelect(activePage) {
        this.setState({ activePage });
    }

    updateFactor(affid, subid, country, type) {
        const cutoff = prompt("Enter new cutoff: ");
        if(!cutoff || isNaN(cutoff)) return alert("Please enter correct number.");

        if(!window.confirm(`Are you sure to set cutoff: ${cutoff} for '${affid}:${subid}:${country}'?`)) return;

        this.setState({ isLoading: true })

        API.DynamicCutoff.updateFactor(affid, subid, country, cutoff, type).then(() => {
            this.setState({ isLoading: false })
        })
    }

    getTable() {
        let { report, activePage } = this.state;

        if(report.length) {
            const pageStart = ( activePage - 1 ) * PAGE_LIMIT;
            const pageEnd = activePage * PAGE_LIMIT;
            report = report.slice(pageStart, pageEnd);

            return <Table report={report} updateFactor={this.updateFactor} onSortChange={this.handleSort} />;
        }

        return <p>No Data</p>
    }


    render() {
        const { isLoading, affidValues, subidValues } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Dynamic Cutoff All"/>
                <Form onSubmit={this.handleSubmit} affidValues={affidValues} subidValues={subidValues}/>

                {this.getTable()}
                <Pagination
                    items={this.state.pagesTotal}
                    maxButtons={20}
                    onSelect={this.handlePageSelect}
                    activePage={this.state.activePage}
                />
            </Container>
        );
    }
}

export default DynamicCutoff;


// WEBPACK FOOTER //
// ./src/scenes/DynamicCutoffAll/index.js